fragment PrintTechniqueFragment on PrintTechnique {
    id
    code
    type
}